import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Idle } from '@ng-idle/core';
import * as jwt_decode from 'jwt-decode';
import { AddressDetailsDto, LinkedAccounts, LoggedInUserDto } from 'src/app/core/interfaces/loggedInUserDto';
import {LoggedInUserLABUDto} from 'src/app/core/interfaces/loggedInUserDto';
import { LoginResponse } from 'src/app/core/interfaces/login-response';
import { HttpService } from 'src/app/core/services/http/http.service';
import { Constants } from 'src/app/shared/constants';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { NotificationService } from 'src/app/shared/services/notification-service';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';
import { BroadcastService } from 'src/app/shared/services/broadcast.service';
import { ChangePassword } from '../../classes/change-password-request';
import { ForgotPassword } from '../../classes/forgot-password-request';
import { SendOtpRequest } from '../../classes/sendOtpRequest';
import { LoginRequest } from '../../interfaces/login-request';
import { IPolicyAcceptanceDetail } from '../../interfaces/policy-acceptance-detail';
import { EndPoints } from 'src/app/shared/EndPoints';
import { environment } from 'src/environments/environment';
import { LinkedAccountDto } from '../../interfaces/linked-account-result';

@Injectable({
    providedIn: 'root'
  })

export class UserInfoService{

    constructor(
        private httpService: HttpService,
        private idle: Idle,
        private router: Router,
        private notification: NotificationService,
        private localStorageService: LocalStorageService,
        private sessionStorageService: SessionStorageService,
        private dialogService: DialogService,
        private broadCastService: BroadcastService
      ) {}


    public GetLoggedInUserLA(pquery: string) {
    return this.httpService.Get<LoggedInUserLABUDto>(
      environment.customerPortalServiceUrl +
      EndPoints.GetUserInfo + pquery
    );
    }

    public GetLoggedInUserLAWithAddressDetail(accountCode: string) {
        return this.httpService.Get<LinkedAccounts>(
          environment.customerPortalServiceUrl +
          EndPoints.GetLAWithAddressByAccountCode + accountCode
        );
    }

    public GetLoggedInUserLAWithAuth(accountCode: string) {
        return this.httpService.Get<LinkedAccounts>(
          environment.customerPortalServiceUrl +
          EndPoints.GetLinkedAccountWithAuthByAccountCode + accountCode
        );
    }

    public HasLinkedAccount() {
        return this.httpService.Get<boolean>(
            environment.customerPortalServiceUrl +
            EndPoints.HasLinkedAccount);
    }
}